import React from "react";
import { connect } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import { Sticky, StickyContainer } from "react-sticky";

import { logout } from "../../../actions/sessionAct";

import { commonErr } from "../../common/errors";
import { LogoutBox } from "../../common/logout";

import {
	IcUser,
	IcHeart,
	IcListCar,
	IcListAddress,
	IcMyTrip,
	IcRewardPromo,
	IcLock,
	IcLogOut,
	IcTrash,
	IcCSTrip
} from "../../common/svg";
import * as ROUTES from "../../../constant/routes";

const url = [
	{ path: ROUTES.ACCOUNT, ic: <IcUser />, name: "Tài khoản của tôi" },
	{ path: ROUTES.MY_FAVS, ic: <IcHeart />, name: "Xe yêu thích" },
	{ path: ROUTES.MY_CARS, ic: <IcListCar />, name: "Xe của tôi" },
	{ path: ROUTES.MY_TRIPS, ic: <IcMyTrip />, name: "Chuyến của tôi" },
	{ path: ROUTES.CS_TRIPS, ic: <IcCSTrip />, name: "Đơn hàng Thuê xe dài hạn" },
	{ path: ROUTES.MY_REWARD, ic: <IcRewardPromo />, name: "Quà tặng" },
	{ path: ROUTES.MY_ADDRESS, ic: <IcListAddress />, name: "Địa chỉ của tôi" },
	{ path: ROUTES.RESET_PW, ic: <IcLock />, name: "Đổi mật khẩu" }
];

class AccountSideBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			isDropdown: false,
			currentUrl: ROUTES.ACCOUNT,
			isLogoutBox: false,
		};

		this.wrapperRef = React.createRef();
	}

	componentDidMount() {
		this.setState({
			currentUrl: window.location.pathname,
		});

		document.addEventListener("click", this.handleClickOutside);
	}

	componentDidUpdate(props, state) {
		if (!props.loginSuccess && this.props.loginSuccess === "YES") {
			this.props.navigation.navigate("Otp");
		}
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		const { target } = event;
		if (!this.wrapperRef.current?.contains(target)) {
			this.hideDropdown();
		}
	};

	toggleDropdown = () => {
		this.setState({
			isDropdown: !this.state.isDropdown,
		});
	};

	hideDropdown = () => {
		this.setState({
			isDropdown: false,
		});
	};

	showConfirmLogout = () => {
		this.setState({
			isLogoutBox: true,
		});
	};

	hideConfirmLogout = () => {
		this.setState({
			isLogoutBox: false,
		});
	};

	logout = () => {
		this.props.dispatch(logout());
	};

	render() {
		const { isDropdown, currentUrl, isLogoutBox } = this.state;

		return (
			<StickyContainer className="sidebar-account">
				<Sticky>
					{({ style }) => (
						<div className="sidebar-account-sticky" style={{ ...style }}>
							<div className="title">
								<h4>Xin chào bạn!</h4>
							</div>
							<div className="sidebar">
								{url.map((item, i) => (
									<NavLink key={i} to={item.path} className="sidebar-item" activeClassName="active">
										<div className="wrap-svg">{item.ic}</div>
										<p>{item.name}</p>
									</NavLink>
								))}

								<div className="sidebar-item" onClick={() => this.showConfirmLogout()}>
									<div className="wrap-svg">
										<IcLogOut />
									</div>
									<p>Đăng xuất</p>
								</div>
								<Link to={ROUTES.DELETE_ACCOUNT} className="sidebar-item">
									<div className="wrap-svg">
										<IcTrash />
									</div>
									<p>Yêu cầu xóa tài khoản</p>
								</Link>
							</div>
						</div>
					)}
				</Sticky>
				<div className="dropdown-sidebar custom-dropdown" ref={this.wrapperRef}>
					<div className="dropdown-selected" onClick={this.toggleDropdown}>
						{url.map((item, i) => {
							if (item.path === currentUrl) {
								return (
									<React.Fragment key={i}>
										<div className="wrap-svg">{item.ic}</div>
										<p>{item.name}</p>
									</React.Fragment>
								);
							}
						})}
					</div>

					{isDropdown && (
						<div className="dropdown-option">
							{url.map((item, i) => (
								<NavLink key={i} to={item.path} onClick={() => this.hideDropdown()} className="dropdown-option__item">
									<div className="wrap-svg">{item.ic}</div>
									<p className="text">{item.name}</p>
								</NavLink>
							))}

							<div className="dropdown-option__item" onClick={() => this.showConfirmLogout()}>
								<div className="wrap-svg">
									<IcLogOut />
								</div>
								<p className="text">Đăng xuất</p>
							</div>
							<Link to={ROUTES.DELETE_ACCOUNT} className="dropdown-option__item">
								<div className="wrap-svg">
									<IcTrash />
								</div>
								<p className="text">Yêu cầu xóa tài khoản</p>
							</Link>
						</div>
					)}
				</div>
				<LogoutBox show={isLogoutBox} onHide={this.hideConfirmLogout} onLogout={this.logout} />
			</StickyContainer>
		);
	}
}
function mapState(state) {
	return {
		session: state.session,
	};
}

AccountSideBar = connect(mapState)(AccountSideBar);

export default AccountSideBar;
